import { render } from "./narasi.vue?vue&type=template&id=6e19a796&scoped=true"
import script from "./narasi.vue?vue&type=script&lang=js"
export * from "./narasi.vue?vue&type=script&lang=js"

import "./narasi.vue?vue&type=style&index=0&id=6e19a796&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e19a796"

export default script